module.exports = __webpack_public_path__ + "img/phone.359bdfd.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/phone.svg
// module id = ./assets/img/phone.svg
// module chunks = 13 19